import { default as Careers } from "./careers-root";

export default Careers;
